var exports = {
  "q": "x31de4314--b5a437--footer",
  "n": "x31de4314--b5a437--link",
};

module.exports = exports;
